import React, {Component} from 'react';
import Datepicker from "../../../../components/Datepicker/datepicker";
import PlateInput from "../../../../components/PlateInput/plateInput";


export default class FiltersDefaultInternal extends Component {

    componentDidMount(){
        window.initializeSelects('.filter');
        window.bindSelectAction(this.productSelect, this.props.selectAction);
        window.bindSelectAction(this.terminalSelect, this.props.selectAction);
        window.bindSelectAction(this.dateTypeSelect, this.props.selectAction);
        window.bindSelectAction(this.statusSelect, this.props.selectAction);
        window.bindSelectAction(this.areaSelect, this.props.selectAction);
    }

    render() {
        return (
            <div className={'filter'}>
                <div className={'row thin-row'}>
                    <div className={'col s3 input-field'}>
                        <select defaultValue={this.props.state.product} data-state-var="product"
                                ref={ref => {
                                    this.productSelect = ref
                                }}>
                            <option value="">Todos</option>
                            {this.props.state.products && this.props.state.products.map(product => {
                                return <option key={product.id} id={product.id}
                                               value={product.id}>{product.name}</option>
                            })}
                        </select>
                        <label>Producto</label>
                    </div>
                    <div className={'col s3 input-field'}>
                        <select defaultValue={this.props.state.terminal} data-state-var="terminal"
                                ref={ref => {this.terminalSelect = ref}}>
                            <option value="">Todos</option>
                            {this.props.state.terminals && this.props.state.terminals.map(terminal => {
                                return <option key={terminal.id} id={terminal.id}
                                               value={terminal.id}>{terminal.name}</option>
                            })}
                        </select>
                        <label>Destino</label>
                    </div>
                    <div className={'col s3 input-field'}>
                        <select defaultValue={this.props.state.destination_area} data-state-var="destination_area"
                                ref={ref => {this.areaSelect = ref}}>
                            <option value="">Todos</option>
                            {this.props.state.destination_areas && this.props.state.destination_areas.map(area => {
                                return <option key={area.id} id={area.id}
                                               value={area.id}>{area.name}</option>
                            })}
                        </select>
                        <label>Area</label>
                    </div>
                    <div className={'col s3 input-field'}>
                        <select defaultValue={this.props.state.status} data-state-var="status"
                                ref={ref => {
                                    this.statusSelect = ref
                                }}>
                            <option value="">Todos</option>
                            {this.props.state.grouped_states && this.props.state.grouped_states.length > 0 &&
                            <optgroup label={'Generales'}>
                                {this.props.state.grouped_states.map(state => {
                                    return <option key={state.id} id={state.id}
                                                   value={state.id}>{state.value}</option>
                                })}
                            </optgroup>
                            }
                            <optgroup label={'Individuales'}>
                            {this.props.state.states && this.props.state.states.map(state => {
                                return <option key={state.id} id={state.id}
                                               value={state.id}>{state.value}</option>
                            })}
                            </optgroup>
                        </select>
                        <label>Estado</label>
                    </div>
                </div>
                <div className={'row thin-row'}>
                    <div className={'col s3 input-field'}>
                        <label className="active">Empresa Transportista</label>
                        <input value={this.props.state.carrier}
                               onChange={(ev) => this.props.inputAction('carrier', ev.target.value)}
                               type="text" placeholder={'Ingrese unidad de transporte'}/>
                    </div>
                    <div className={'col s3 input-field'}>
                        <label className="active">Chofer</label>
                        <input value={this.props.state.driver_name}
                            onChange={(ev) => this.props.inputAction('driver_name', ev.target.value)}
                            type="text" placeholder={'Ingrese el nombre o apellido del chofer'}/>
                    </div>
                    <div className={'col s2 input-field'}>
                        <label className="active">Unidad de transporte</label>
                        <input value={this.props.state.truck_id}
                            onChange={(ev) => this.props.inputAction('truck_id', ev.target.value)}
                            type="text" placeholder={'Ingrese la unidad'}/>
                    </div>
                    <div className={'col s2 input-field'}>
                        <label className="active">Patente chasis</label>
                        <PlateInput
                            placeholder="Ingrese patente del chasis" value={this.props.state.truck_plate}
                            name={'truck_plate'} action={this.props.inputAction}
                        />
                    </div>
                    <div className={'col s2 input-field'}>
                        <label className="active">Patente acoplado</label>
                        <PlateInput
                            placeholder="Ingrese patente del acoplado" value={this.props.state.trailer_plate}
                            action={this.props.inputAction} name={'trailer_plate'}
                        />
                    </div>
                </div>
                <div className={'row thin-row'} style={{position: 'relative'}}>
                    <div className={'col s2 input-field'}>
                        <select defaultValue={this.props.state.date_type} data-state-var="date_type"
                                ref={ref => {this.dateTypeSelect = ref}}>
                            <option value="estimated_load_date">Carga estimada</option>
                            <option value="load_datetime">Carga</option>
                            <option value="unload_date">Descarga</option>
                        </select>
                        <label>Fecha</label>
                    </div>
                    <div className={'col s5'} style={{position: 'relative'}}>
                        <Datepicker value={this.props.state.gte} format={"YYYY-MM-DD"}
                                    id="gte" action={this.props.dateAction}
                                    classname="col s3" style={{position: 'relative', marginTop: 15}}/>
                        <div className={'col s1'} style={{marginTop: 25, marginLeft: 20}}>
                            <p style={{position: 'absolute'}}>a</p>
                        </div>
                        <Datepicker value={this.props.state.lte} format={"YYYY-MM-DD"}
                                    id="lte" action={this.props.dateAction}
                                    classname="col s3" style={{position: 'relative', marginTop: 15}}/>
                    </div>
                    <div className={'col s5'}>
                        <a onClick={() => {
                            window.location.reload()
                        }} style={{
                            color: "#000000",
                            fontWeight: 'bold',
                            position: 'absolute',
                            bottom: 0,
                            right: 0
                        }}>
                            Borrar filtros</a>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/Dashboard/Home/Filters/FiltersDefaultInternal.js